import { render, staticRenderFns } from "./TreeViewFluxoDeCaixa.vue?vue&type=template&id=6b3c5856"
import script from "./TreeViewFluxoDeCaixa.vue?vue&type=script&lang=js"
export * from "./TreeViewFluxoDeCaixa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports